export const OLD_TESTAMENT_BOOKS = [
  'Genesis',
  'Exodus',
  'Leviticus',
  'Numbers',
  'Deuteronomy',
  'Joshua',
  'Judges',
  'Ruth',
  '1Samuel',
  '2Samuel',
  '1Kings',
  '2Kings',
  '1Chronicles',
  '2Chronicles',
  'Ezra',
  'Nehemiah',
  'Esther',
  'Job',
  'Psalms',
  'Proverbs',
  'Ecclesiastes',
  'SongofSolomon',
  'Isaiah',
  'Jeremiah',
  'Lamentations',
  'Ezekiel',
  'Daniel',
  'Hosea',
  'Joel',
  'Amos',
  'Obadiah',
  'Jonah',
  'Micah',
  'Nahum',
  'Habakkuk',
  'Zephaniah',
  'Haggai',
  'Zechariah',
  'Malachi',
];

export const NEW_TESTAMENT_BOOKS = [
  'Matthew',
  'Mark',
  'Luke',
  'John',
  'Acts',
  'Romans',
  '1Corinthians',
  '2Corinthians',
  'Galatians',
  'Ephesians',
  'Philippians',
  'Colossians',
  '1Thessalonians',
  '2Thessalonians',
  '1Timothy',
  '2Timothy',
  'Titus',
  'Philemon',
  'Hebrews',
  'James',
  '1Peter',
  '2Peter',
  '1John',
  '2John',
  '3John',
  'Jude',
  'Revelation',
];

export const OLD_TESTAMENT_CHAPTER_COUNTS = {
  Genesis: 50,
  Exodus: 40,
  Leviticus: 27,
  Numbers: 36,
  Deuteronomy: 34,
  Joshua: 24,
  Judges: 21,
  Ruth: 4,
  '1Samuel': 31,
  '2Samuel': 24,
  '1Kings': 22,
  '2Kings': 25,
  '1Chronicles': 29,
  '2Chronicles': 36,
  Ezra: 10,
  Nehemiah: 13,
  Esther: 10,
  Job: 42,
  Psalms: 150,
  Proverbs: 31,
  Ecclesiastes: 12,
  SongofSolomon: 8,
  Isaiah: 66,
  Jeremiah: 52,
  Lamentations: 5,
  Ezekiel: 48,
  Daniel: 12,
  Hosea: 14,
  Joel: 3,
  Amos: 9,
  Obadiah: 1,
  Jonah: 4,
  Micah: 7,
  Nahum: 3,
  Habakkuk: 3,
  Zephaniah: 3,
  Haggai: 2,
  Zechariah: 14,
  Malachi: 4,
};

export const NEW_TESTAMENT_CHAPTER_COUNTS = {
  Matthew: 28,
  Mark: 16,
  Luke: 24,
  John: 21,
  Acts: 28,
  Romans: 16,
  '1Corinthians': 16,
  '2Corinthians': 13,
  Galatians: 6,
  Ephesians: 6,
  Philippians: 4,
  Colossians: 4,
  '1Thessalonians': 5,
  '2Thessalonians': 3,
  '1Timothy': 6,
  '2Timothy': 4,
  Titus: 3,
  Philemon: 1,
  Hebrews: 13,
  James: 5,
  '1Peter': 5,
  '2Peter': 3,
  '1John': 5,
  '2John': 1,
  '3John': 1,
  Jude: 1,
  Revelation: 22,
};

export const TESTAMENTS = {
  old: {
    id: 'old',
    routeSegment: 'old-testament',
    sectionId: 1,
    titleKey: 'OldTestament',
    books: OLD_TESTAMENT_BOOKS,
    chapterCounts: OLD_TESTAMENT_CHAPTER_COUNTS,
  },
  new: {
    id: 'new',
    routeSegment: 'new-testament',
    sectionId: 2,
    titleKey: 'NewTestament',
    books: NEW_TESTAMENT_BOOKS,
    chapterCounts: NEW_TESTAMENT_CHAPTER_COUNTS,
  },
};

export const normalizeBookKey = (bookName = '') => {
  return String(bookName).replace(/\s+/g, '').trim();
};

export const getTestamentConfig = (testamentType = 'old') => {
  return TESTAMENTS[testamentType] || TESTAMENTS.old;
};

export const getBookList = (testamentType = 'old') => {
  return getTestamentConfig(testamentType).books;
};

export const getChapterCount = (testamentType = 'old', bookName) => {
  const key = normalizeBookKey(bookName);
  const config = getTestamentConfig(testamentType);

  return config.chapterCounts[key] || 0;
};

export const getLanguageKey = (language = 'Tamil') => {
  const value = String(language).trim().toLowerCase();

  if (value === 'english') return 'english';
  if (value === 'deutsch') return 'deutsch';
  if (value === 'tamil' || value === 'தமிழ்') return 'tamil';

  return 'tamil';
};

export const getChapterLabel = (language, chapterNumber) => {
  const languageKey = getLanguageKey(language);

  if (languageKey === 'english') {
    return `CHAPTER ${chapterNumber}`;
  }

  if (languageKey === 'deutsch') {
    return `KAPITEL ${chapterNumber}`;
  }

  return `அதிகாரம் ${chapterNumber}`;
};

export const getTableHeadersByLanguage = (language) => {
  const languageKey = getLanguageKey(language);

  if (languageKey === 'english') {
    return { number: 'No.', books: 'Books' };
  }

  if (languageKey === 'deutsch') {
    return { number: 'Nr.', books: 'Bücher' };
  }

  return { number: 'இல.', books: 'ஆகமங்கள்' };
};

export const getNotFoundText = (language) => {
  const languageKey = getLanguageKey(language);

  if (languageKey === 'english') return 'Book not found';
  if (languageKey === 'deutsch') return 'Buch nicht gefunden';

  return 'ஆகமம் கிடைக்கவில்லை';
};

export const getNavigationText = (language) => {
  const languageKey = getLanguageKey(language);

  if (languageKey === 'english') {
    return {
      books: 'Books',
      previous: 'Previous',
      next: 'Next',
      loading: 'Loading...',
      notFound: 'Book not found',
    };
  }

  if (languageKey === 'deutsch') {
    return {
      books: 'Bücher',
      previous: 'Zurück',
      next: 'Weiter',
      loading: 'Laden...',
      notFound: 'Buch nicht gefunden',
    };
  }

  return {
    books: 'ஆகமங்கள்',
    previous: 'முந்தையது',
    next: 'அடுத்தது',
    loading: 'ஏற்றுகிறது...',
    notFound: 'ஆகமம் கிடைக்கவில்லை',
  };
};

export const getLanguageLabel = (languageKey) => {
  if (languageKey === 'tamil') return 'தமிழ்';
  if (languageKey === 'english') return 'English';
  return 'Deutsch';
};

export const getEnglishBookName = (bookName) => {
  const key = normalizeBookKey(bookName);

  const bookNameMap = {
    OldTestament: 'Old Testament',
    NewTestament: 'New Testament',

    Genesis: 'Genesis',
    Exodus: 'Exodus',
    Leviticus: 'Leviticus',
    Numbers: 'Numbers',
    Deuteronomy: 'Deuteronomy',
    Joshua: 'Joshua',
    Judges: 'Judges',
    Ruth: 'Ruth',
    '1Samuel': '1 Samuel',
    '2Samuel': '2 Samuel',
    '1Kings': '1 Kings',
    '2Kings': '2 Kings',
    '1Chronicles': '1 Chronicles',
    '2Chronicles': '2 Chronicles',
    Ezra: 'Ezra',
    Nehemiah: 'Nehemiah',
    Esther: 'Esther',
    Job: 'Job',
    Psalms: 'Psalms',
    Proverbs: 'Proverbs',
    Ecclesiastes: 'Ecclesiastes',
    SongofSolomon: 'Song of Solomon',
    Isaiah: 'Isaiah',
    Jeremiah: 'Jeremiah',
    Lamentations: 'Lamentations',
    Ezekiel: 'Ezekiel',
    Daniel: 'Daniel',
    Hosea: 'Hosea',
    Joel: 'Joel',
    Amos: 'Amos',
    Obadiah: 'Obadiah',
    Jonah: 'Jonah',
    Micah: 'Micah',
    Nahum: 'Nahum',
    Habakkuk: 'Habakkuk',
    Zephaniah: 'Zephaniah',
    Haggai: 'Haggai',
    Zechariah: 'Zechariah',
    Malachi: 'Malachi',

    Matthew: 'Matthew',
    Mark: 'Mark',
    Luke: 'Luke',
    John: 'John',
    Acts: 'Acts',
    Romans: 'Romans',
    '1Corinthians': '1 Corinthians',
    '2Corinthians': '2 Corinthians',
    Galatians: 'Galatians',
    Ephesians: 'Ephesians',
    Philippians: 'Philippians',
    Colossians: 'Colossians',
    '1Thessalonians': '1 Thessalonians',
    '2Thessalonians': '2 Thessalonians',
    '1Timothy': '1 Timothy',
    '2Timothy': '2 Timothy',
    Titus: 'Titus',
    Philemon: 'Philemon',
    Hebrews: 'Hebrews',
    James: 'James',
    '1Peter': '1 Peter',
    '2Peter': '2 Peter',
    '1John': '1 John',
    '2John': '2 John',
    '3John': '3 John',
    Jude: 'Jude',
    Revelation: 'Revelation',
  };

  return bookNameMap[key] || bookName;
};

export const getTamilBookName = (bookName) => {
  const key = normalizeBookKey(bookName);

  const bookNameMap = {
    OldTestament: 'பழைய ஏற்பாடு',
    NewTestament: 'புதிய ஏற்பாடு',

    Genesis: 'ஆதியாகமம்',
    Exodus: 'யாத்திராகமம்',
    Leviticus: 'லேவியராகமம்',
    Numbers: 'எண்ணாகமம்',
    Deuteronomy: 'உபாகமம்',
    Joshua: 'யோசுவா',
    Judges: 'நியாயாதிபதிகள்',
    Ruth: 'ரூத்',
    '1Samuel': '1 சாமுவேல்',
    '2Samuel': '2 சாமுவேல்',
    '1Kings': '1 இராஜாக்கள்',
    '2Kings': '2 இராஜாக்கள்',
    '1Chronicles': '1 நாளாகமம்',
    '2Chronicles': '2 நாளாகமம்',
    Ezra: 'எஸ்றா',
    Nehemiah: 'நெகேமியா',
    Esther: 'எஸ்தர்',
    Job: 'யோபு',
    Psalms: 'சங்கீதம்',
    Proverbs: 'நீதிமொழிகள்',
    Ecclesiastes: 'பிரசங்கி',
    SongofSolomon: 'உன்னதப்பாட்டு',
    Isaiah: 'ஏசாயா',
    Jeremiah: 'எரேமியா',
    Lamentations: 'புலம்பல்',
    Ezekiel: 'எசேக்கியேல்',
    Daniel: 'தானியேல்',
    Hosea: 'ஓசியா',
    Joel: 'யோவேல்',
    Amos: 'ஆமோஸ்',
    Obadiah: 'ஒபதியா',
    Jonah: 'யோனா',
    Micah: 'மீகா',
    Nahum: 'நாகூம்',
    Habakkuk: 'ஆபகூக்',
    Zephaniah: 'செப்பனியா',
    Haggai: 'ஆகாய்',
    Zechariah: 'சகரியா',
    Malachi: 'மல்கியா',

    Matthew: 'மத்தேயு',
    Mark: 'மாற்கு',
    Luke: 'லூக்கா',
    John: 'யோவான்',
    Acts: 'அப்போஸ்தலருடைய நடபடிகள்',
    Romans: 'ரோமர்',
    '1Corinthians': '1 கொரிந்தியர்',
    '2Corinthians': '2 கொரிந்தியர்',
    Galatians: 'கலாத்தியர்',
    Ephesians: 'எபேசியர்',
    Philippians: 'பிலிப்பியர்',
    Colossians: 'கொலோசெயர்',
    '1Thessalonians': '1 தெசலோனிக்கேயர்',
    '2Thessalonians': '2 தெசலோனிக்கேயர்',
    '1Timothy': '1 தீமோத்தேயு',
    '2Timothy': '2 தீமோத்தேயு',
    Titus: 'தீத்து',
    Philemon: 'பிலேமோன்',
    Hebrews: 'எபிரெயர்',
    James: 'யாக்கோபு',
    '1Peter': '1 பேதுரு',
    '2Peter': '2 பேதுரு',
    '1John': '1 யோவான்',
    '2John': '2 யோவான்',
    '3John': '3 யோவான்',
    Jude: 'யூதா',
    Revelation: 'வெளிப்படுத்தின விசேஷம்',
  };

  return bookNameMap[key] || bookName;
};

export const getDeutschBookName = (bookName) => {
  const key = normalizeBookKey(bookName);

  const bookNameMap = {
    OldTestament: 'Altes Testament',
    NewTestament: 'Neues Testament',

    Genesis: '1. Mose',
    Exodus: '2. Mose',
    Leviticus: '3. Mose',
    Numbers: '4. Mose',
    Deuteronomy: '5. Mose',
    Joshua: 'Josua',
    Judges: 'Richter',
    Ruth: 'Rut',
    '1Samuel': '1. Samuel',
    '2Samuel': '2. Samuel',
    '1Kings': '1. Könige',
    '2Kings': '2. Könige',
    '1Chronicles': '1. Chronik',
    '2Chronicles': '2. Chronik',
    Ezra: 'Esra',
    Nehemiah: 'Nehemia',
    Esther: 'Ester',
    Job: 'Hiob',
    Psalms: 'Psalter',
    Proverbs: 'Sprüche',
    Ecclesiastes: 'Prediger',
    SongofSolomon: 'Hohelied',
    Isaiah: 'Jesaja',
    Jeremiah: 'Jeremia',
    Lamentations: 'Klagelieder',
    Ezekiel: 'Hesekiel',
    Daniel: 'Daniel',
    Hosea: 'Hosea',
    Joel: 'Joel',
    Amos: 'Amos',
    Obadiah: 'Obadja',
    Jonah: 'Jona',
    Micah: 'Micha',
    Nahum: 'Nahum',
    Habakkuk: 'Habakuk',
    Zephaniah: 'Zefanja',
    Haggai: 'Haggai',
    Zechariah: 'Sacharja',
    Malachi: 'Maleachi',

    Matthew: 'Matthäus',
    Mark: 'Markus',
    Luke: 'Lukas',
    John: 'Johannes',
    Acts: 'Apostelgeschichte',
    Romans: 'Römer',
    '1Corinthians': '1. Korinther',
    '2Corinthians': '2. Korinther',
    Galatians: 'Galater',
    Ephesians: 'Epheser',
    Philippians: 'Philipper',
    Colossians: 'Kolosser',
    '1Thessalonians': '1. Thessalonicher',
    '2Thessalonians': '2. Thessalonicher',
    '1Timothy': '1. Timotheus',
    '2Timothy': '2. Timotheus',
    Titus: 'Titus',
    Philemon: 'Philemon',
    Hebrews: 'Hebräer',
    James: 'Jakobus',
    '1Peter': '1. Petrus',
    '2Peter': '2. Petrus',
    '1John': '1. Johannes',
    '2John': '2. Johannes',
    '3John': '3. Johannes',
    Jude: 'Judas',
    Revelation: 'Offenbarung',
  };

  return bookNameMap[key] || bookName;
};

export const getBookNameByLanguage = (bookName, language) => {
  const languageKey = getLanguageKey(language);

  if (languageKey === 'english') {
    return getEnglishBookName(bookName);
  }

  if (languageKey === 'deutsch') {
    return getDeutschBookName(bookName);
  }

  return getTamilBookName(bookName);
};